var map = {
	"./amex.png": "fea8",
	"./chip.png": "e0c9",
	"./dinersclub.png": "69f4",
	"./discover.png": "469c",
	"./elo.png": "bd42",
	"./jcb.png": "a775",
	"./mastercard.png": "702c",
	"./troy.png": "aab3",
	"./unionpay.png": "2ddc",
	"./visa.png": "f9db",
	"./visaelectron.png": "59cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e14";